import React, { Component } from "react";
import { hot } from "react-hot-loader";
import { Alert, Collapse } from "antd";
const Panel = Collapse.Panel;

function DeveloperNote(props) {
  return (
    <div>
      <Collapse defaultActiveKey={["1"]}>
        <Panel header="Developers note:" key="1">
          <h2> {props.children}</h2>
        </Panel>
      </Collapse>
      <br />
    </div>
  );
  //console.log({ props });
  return <Alert type="warning" message={props.children} />;
}
export default hot(module)(DeveloperNote);
